import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ErrorParser } from '@app/classes';
import { NotifyService } from '@app/services';
import { PayrollSettingsService, Settings } from '@app/services/payroll-settings.service';
import { PayrollSelfOnboardingService } from '@payroll/services';
import { Subscription } from 'rxjs';

@Injectable()
export class SelfOnboardingCompleteGuard {
    payrollSettingsServiceSubscription$: Subscription;
    payrollSettings: Settings;

    constructor(
        private payrollSelfOnboardingService: PayrollSelfOnboardingService,
        private router: Router,
        private payrollSettingsService: PayrollSettingsService,
        private notify: NotifyService
    ) {
        this.payrollSettingsServiceSubscription$ = this.payrollSettingsService.settings$.subscribe((settings) => {
            this.payrollSettings = settings;
        });
    }

    async canActivate(_routeSnapshot: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<UrlTree> {
        try {
            await this.payrollSettingsService.load();
            this.payrollSettingsServiceSubscription$.unsubscribe();
            if (!this.payrollSettings.showOnboardingMenu) {
                return this.router.parseUrl('/payroll/run');
            }
        } catch (error) {
            this.notify.error(ErrorParser.parse(error));
            return this.router.parseUrl('/dashboard');
        }

        const selfOnboardingComplete = await this.payrollSelfOnboardingService.getSelfOnboardingIsComplete();
        return !selfOnboardingComplete
            ? this.router.parseUrl('/payroll/self-onboarding')
            : this.router.parseUrl('/payroll/run');
    }
}
